import { ActionTypes } from '../../actions/constants';

const initialState = {
    isSearching: false,
    hasSearched: false,
};

export default function statusReducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.SEARCH_STARTED:
            return {
                isSearching: true,
                hasSearched: true,
            };

        case ActionTypes.SEARCH_COMPLETED:
        case ActionTypes.SEARCH_FAILED:
            return {
                isSearching: false,
                hasSearched: true,
            };

        default:
            return state;
    }
}
